import React, { useCallback, useState } from "react";
import { FieldProps } from "react-jsonschema-form";
import { JsonEditor as Editor } from "jsoneditor-react";
import "jsoneditor-react/es/editor.min.css";
import Selector from "../../../components/selector";
import { WitLabel } from "../../shared/widgets/common";
import { FormattedMessage } from "react-intl";

export enum Mode {
  form = "form",
  tree = "tree",
  code = "code",
}

type Option = { value: Mode; label: Mode };

export function CustomJsonEditor({ formData, onChange, schema, helperReference, helperReferenceTitle }: FieldProps) {
  const modeOptions: Option[] = Object.entries(Mode).map(([, val]) => ({
    value: val,
    label: val,
  }));
  const [editorKey, setEditorKey] = useState<number>(Math.random());
  const [mode, setMode] = useState<Option>(modeOptions[0]);

  const handleSelectMode = useCallback((selectedOption: Option) => {
    setMode(selectedOption);
    setEditorKey(Math.random);
  }, []);

  const handleChange = useCallback((json: string) => onChange(json), [onChange]);
  
  return (
    <>
      <WitLabel>{schema?.title}</WitLabel>
      <div className="d-flex">
        <div className="w-50">
          <Selector options={modeOptions} value={mode} onChange={handleSelectMode} />
          <Editor
            htmlElementProps={{ style: { height: "600px" } }}
            key={editorKey}
            mode={mode.value}
            history
            value={formData}
            onChange={handleChange}
          />
        </div>
        <div className="w-50 pl-3">
          {helperReferenceTitle && (<p className="font-weight-bold pb-3">{helperReferenceTitle}</p>)}
          {helperReference}
        </div>
      </div>
    </>
  );
}
